import * as moment from 'moment';
import {IStation, IDischargeModel, IDailyTriplet} from '../../api/api.types';
import {OnChanges, IChangeIndication} from '../../common/common.types';
import {IDailyDataRequest} from '../../api/data-value-api.service';
import {IFinalTelegramData} from './data-processing.controller'
import {IIcePhenomenaCardData} from './kn15-telegram/ice-phenomena-card.component';

export interface IProcessedDataCell {
  waterLevel: number;
  discharge: number;
  highlighted: boolean;
}

export interface IProcessedDataRow {
  date: moment.Moment;
  morningCell?: IProcessedDataCell;
  eveningCell?: IProcessedDataCell;
  averageCell?: IProcessedDataCell;
}

export default class OperationalInputSaveController implements OnChanges {

  processedData: IDailyDataRequest[];


  constructor() {
  }

  $onChanges(changes: IChangeIndication) {

    if(changes.hasOwnProperty('processedData') && changes['processedData'].currentValue) {
      this.processedData = changes['processedData'].currentValue;
    }
    // this.resetView();
    // this.notifyProcessedData();
    // if (this.station && this.parsedTelegram && this.dischargeModel) {
    //   this.loadPreviousDailyData();
    //   this.buildIcePhenomenaCard();
    //   this.buildDischargeCard();
    //   this.buildMeteoCard();
    // }
  }

  private buildDischargeCard(telegramData: IFinalTelegramData) {
    return telegramData.dailyDataParams.dischargeData && telegramData.dailyDataParams.dischargeData.dischargeMeasurementData 
  }

  private buildMeteoCard(telegramData: IFinalTelegramData) {
    return telegramData.dailyDataParams.meteoData
  }
}




/** WEBPACK FOOTER **
 ** ./app/operational/input/save.controller.ts
 **/